import { useQuery } from "react-query";
import {
  getLeasedEquipment,
  getLeasedEquipmentCount,
} from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentCount = () => {
  return useQuery("GetLeasedEquipmentCount", getLeasedEquipmentCount, {
    refetchOnWindowFocus: false,
  });
};
